<template>

    <div class="users" ref="users">
    
        <div class="columns is-multiline organization">

            <div class="column is-12" v-if="selectedOrganization">
            
                <div class="card organization-form">
            
                    <header class="card-header has-background-dark">
            
                        <p class="card-header-title has-text-light">
            
                            <span>{{ selectedOrganization.name | uppercase }}</span>
            
                        </p>
            
                    </header>

                    <br>

                    <user :organization-id="selectedOrganization.id" :height="tabHeight" />

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import OrganizationTable from "../partials/organizationTable";

import User from "../partials/user";

import { FirmService } from "@/services/firm.service";

import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";

export default {

  components: {

    OrganizationTable,
    
    User,
  
  },
  
  data: () => ({
  
    firmService: FirmService,

    selectedOrganization: null,
    
    fullHeight: 0,
    
    creating: false,
    
    activeTab: 0,
    
    loading: false,
    
    archiving: false,
    
    restoring: false,
    
    deleting: false,

    archived: false

  }),
  computed: {
    tabHeight() {
      const spacesOnTop = 32 + 16; // Tabs height, Tab content top padding
      return this.fullHeight - spacesOnTop;
    },
    scrollableHeight() {
      return this.tabHeight - 44 - 56; // header height, footer height
    },


  },
  mounted() {
    this.fullHeight = this.$refs.users.clientHeight;

    this.getOrganization();

  },

  methods: {
    async restore() {
      this.restoring = true;

      try {
        const response = await this.firmService.restore(
          this.selectedOrganization.id
        );
        const firm = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "ORGANISATION RESTORED",
          type: "is-info",
          position: "is-top-center"
        });
        this.onRestoreSuccess(firm);
      } catch (err) {}

      this.restoring = false;
    },
    async archive() {
      this.archiving = true;

      try {
        const response = await this.firmService.archive(
          this.selectedOrganization.id
        );
        const firm = JsonDenormalizer.denormalize(response);

        this.$buefy.toast.open({
          message: "ORGANISATION ARCHIVED",
          type: "is-info",
          position: "is-top-center"
        });
        this.onArchiveSuccess(firm);
      } catch (err) {}

      this.archiving = false;
    },
    onRemove() {
      this.$buefy.dialog.confirm({
        title: "Confirm",
        message: "Are you sure you want to <b>delete</b> this organisation?",
        confirmText: "Delete",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.remove();
        }
      });
    },
    async remove() {
      this.deleting = true;

      try {
        await this.firmService.delete(this.selectedOrganization.id);

        this.$buefy.toast.open({
          message: "Organisation has been deleted.",
          type: "is-info",
          position: "is-top-right"
        });
        this.onRemoveSuccess();
      } catch (err) {}

      this.deleting = false;
    },
    fetchOrganizationTableData(selected) {
      return this.$refs.organizationTable.fetch();
    },
    onCreateSuccess() {
      this.fetchOrganizationTableData();
    },
    onUpdateSuccess(firm) {
      this.selectedOrganization = firm;
      this.fetchOrganizationTableData();
    },
    onArchiveSuccess(firm) {
      this.selectedOrganization = firm;
      this.fetchOrganizationTableData();
    },
    onRestoreSuccess(firm) {
      this.selectedOrganization = firm;
      this.fetchOrganizationTableData();
    },
    async onRemoveSuccess() {
      await this.fetchOrganizationTableData();
      this.selectedOrganization = null;
    },

    fetchData() {

      this.archived = !this.archived;
      
      this.$nextTick(() => {

        this.fetchOrganizationTableData();
      
      })

    },


    getOrganization() {

    	let firmId = this.$store.state.Auth.user.firmId;

    	FirmService.show(firmId).then(response => {

    		this.selectedOrganization = JsonDenormalizer.denormalize(response);

    	});

    }



  }
};

</script>

<style scoped>
  .users {
      height: calc(88vh - 44px - 56px);
      .tab-content {
          padding: 16px 0px 0px 0px;
      }
  }

  .hide-show-archive{
    margin: 8px;
  }

</style>


// WEBPACK FOOTER //
// src/components/pages/Users/list-new/includes/user.vue